import apiClient from './api'

/** Semáforo de un componente (ver backend: ComponentState). */
export type ComponentStatus = 'OK' | 'UPDATE' | 'MAJOR' | 'EOL_SOON' | 'EOL' | 'UNKNOWN' | 'ERROR'
export type RoadmapPriority = 'ALTA' | 'MEDIA' | 'BAJA'
export type RoadmapStatus = 'PENDIENTE' | 'EN_CURSO' | 'HECHO' | 'DESCARTADO'

export interface MaintenanceComponent {
    id: string
    name: string
    category: string
    role: string
    shared: boolean
    docs: string | null
    procedure: string | null
    currentVersion: string | null
    currentSource: string | null
    latestVersion: string | null
    newestCycle: string | null
    eolDate: string | null
    status: ComponentStatus
    detail: string
    checkedAt: string | null
}

export interface MaintenanceOverview {
    running: boolean
    lastRun: {
        startedAt: string
        finishedAt: string | null
        trigger: 'SCHEDULED' | 'MANUAL'
        triggeredBy: string | null
        summary: string | null
        alertCount: number
    } | null
    hostInventoryAt: string | null
    components: MaintenanceComponent[]
}

export interface RoadmapItem {
    id: number
    componentId: string | null
    kind: ComponentStatus | null
    source: 'AUTO' | 'MANUAL'
    title: string
    description: string | null
    priority: RoadmapPriority
    status: RoadmapStatus
    dueDate: string | null
    createdBy: string | null
    createdAt: string
    updatedAt: string
    resolvedAt: string | null
}

export interface RoadmapInput {
    componentId?: string
    title?: string
    description?: string
    priority?: RoadmapPriority
    status?: RoadmapStatus
    dueDate?: string
}

export interface Procedure {
    id: string
    title: string
    content: string | null
}

const BASE = '/api/v1/platform/maintenance'

/** Back office "Mantenimiento técnico" (solo SYSTEM_ADMIN). */
export const maintenanceService = {
    async overview(): Promise<MaintenanceOverview> {
        return (await apiClient.get(`${BASE}/overview`)).data
    },
    async startCheck(): Promise<void> {
        await apiClient.post(`${BASE}/check`)
    },
    async roadmap(includeClosed: boolean): Promise<RoadmapItem[]> {
        return (await apiClient.get(`${BASE}/roadmap`, { params: { includeClosed } })).data
    },
    async createItem(input: RoadmapInput): Promise<RoadmapItem> {
        return (await apiClient.post(`${BASE}/roadmap`, input)).data
    },
    async updateItem(id: number, input: RoadmapInput): Promise<RoadmapItem> {
        return (await apiClient.patch(`${BASE}/roadmap/${id}`, input)).data
    },
    async deleteItem(id: number): Promise<void> {
        await apiClient.delete(`${BASE}/roadmap/${id}`)
    },
    async procedures(): Promise<Procedure[]> {
        return (await apiClient.get(`${BASE}/procedures`)).data
    },
    async procedure(id: string): Promise<Procedure> {
        return (await apiClient.get(`${BASE}/procedures/${id}`)).data
    },
}
